const SignOut = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 3V21H8V20H19V4H8V3H20ZM11.1 15.1L11.8 15.8L16.2 11.4L11.8 7L11.1 7.7L14.2 10.8H3V11.8H14.3L11.1 15.1Z" fill="black" />
    </svg>
);
export default SignOut;